export default __webpack_public_path__ + "static/media/1838.d9d7cb67.png";